// School Events Data
const events = [
  // Upcoming October 2026 events
  {
    id: 'oct-14-2026-ms-applications',
    title: 'Middle School & High School Applications',
    titleES: 'Solicitudes de Escuela Intermedia y Preparatoria',
    date: new Date(2026, 9, 14),
    category: 'academic',
    allDay: true,
    description: 'Middle school and high school applications are open this month on MySchools. The middle school application window runs October 14 – December 11, 2026.',
    descriptionES: 'Las solicitudes de escuela intermedia y preparatoria están abiertas este mes en MySchools. El período de solicitud de escuela intermedia es del 14 de octubre al 11 de diciembre de 2026.'
  },
  {
    id: 'oct-16-2026-wear-pink',
    title: 'Wear Pink for Breast Cancer Awareness',
    titleES: 'Vístete de Rosa por la Concientización sobre el Cáncer de Mama',
    date: new Date(2026, 9, 16),
    category: 'community',
    allDay: true,
    description: 'Students and staff are invited to wear pink to show support for Breast Cancer Awareness.',
    descriptionES: 'Se invita a estudiantes y personal a vestirse de rosa para apoyar la concientización sobre el cáncer de mama.'
  },
  {
    id: 'oct-20-2026-food-pantry',
    title: 'Food Pantry (Every Tuesday)',
    titleES: 'Despensa de Alimentos (Todos los Martes)',
    date: new Date(2026, 9, 20),
    category: 'community',
    startTime: '2:30 PM',
    endTime: '3:00 PM',
    location: 'Main Lobby',
    description: 'Free groceries for PS 96 families, brought to us by Global Kids. The food pantry is open every Tuesday starting today.',
    descriptionES: 'Alimentos gratis para las familias de PS 96, gracias a Global Kids. La despensa de alimentos abre todos los martes a partir de hoy.'
  },
  {
    id: 'oct-23-2026-movie-night',
    title: 'Family Movie Night: Hotel Transylvania',
    titleES: 'Noche de Cine Familiar: Hotel Transylvania',
    date: new Date(2026, 9, 23),
    category: 'community',
    startTime: '3:00 PM',
    description: '$5.00 per family (cash only!) includes the movie, popcorn, a drink, and candy for everyone. Students must be accompanied by an adult.',
    descriptionES: '$5.00 por familia (¡solo efectivo!) incluye la película, palomitas de maíz, bebida y dulces para todos. Los estudiantes deben estar acompañados por un adulto.'
  },
  {
    id: 'oct-27-2026-food-pantry',
    title: 'Food Pantry (Every Tuesday)',
    titleES: 'Despensa de Alimentos (Todos los Martes)',
    date: new Date(2026, 9, 27),
    category: 'community',
    startTime: '2:30 PM',
    endTime: '3:00 PM',
    location: 'Main Lobby',
    description: 'Free groceries for PS 96 families, brought to us by Global Kids. The food pantry is open every Tuesday.',
    descriptionES: 'Alimentos gratis para las familias de PS 96, gracias a Global Kids. La despensa de alimentos abre todos los martes.'
  },
  {
    id: 'oct-30-2026-monster-mash',
    title: 'Costume Contest & Monster Mash Party',
    titleES: 'Concurso de Disfraces y Fiesta Monster Mash',
    date: new Date(2026, 9, 30),
    category: 'community',
    description: 'Classes that earn a combined $1,000 ClassBank dollars earn entry. Grades K–2: 9:30–10:10 AM. Grades 3–5: 10:20–11:00 AM. Grades 6–8: 1:40–2:10 PM. Costume contest prizes: 1st $100, 2nd $50, 3rd $25 ClassBank.',
    descriptionES: 'Las clases que ganen un total de $1,000 dólares de ClassBank obtienen acceso. Grados K–2: 9:30–10:10 AM. Grados 3–5: 10:20–11:00 AM. Grados 6–8: 1:40–2:10 PM. Premios del concurso de disfraces: 1.º $100, 2.º $50, 3.º $25 de ClassBank.'
  },
  // December 2026 Events
  {
    id: 'dec-1-2026-book-fair',
    title: 'Scholastic Book Fair',
    titleES: 'Feria del Libro Scholastic',
    date: new Date(2026, 11, 1),
    category: 'community',
    allDay: true,
    description: 'The Scholastic Book Fair runs Monday, November 30 through Friday, December 4.',
    descriptionES: 'La Feria del Libro Scholastic se realiza del lunes 30 de noviembre al viernes 4 de diciembre.'
  },
  {
    id: 'dec-2-2026-book-fair',
    title: 'Scholastic Book Fair',
    titleES: 'Feria del Libro Scholastic',
    date: new Date(2026, 11, 2),
    category: 'community',
    allDay: true,
    description: 'The Scholastic Book Fair runs Monday, November 30 through Friday, December 4.',
    descriptionES: 'La Feria del Libro Scholastic se realiza del lunes 30 de noviembre al viernes 4 de diciembre.'
  },
  {
    id: 'dec-3-2026-book-fair',
    title: 'Scholastic Book Fair',
    titleES: 'Feria del Libro Scholastic',
    date: new Date(2026, 11, 3),
    category: 'community',
    allDay: true,
    description: 'The Scholastic Book Fair runs Monday, November 30 through Friday, December 4.',
    descriptionES: 'La Feria del Libro Scholastic se realiza del lunes 30 de noviembre al viernes 4 de diciembre.'
  },
  {
    id: 'dec-4-2026-book-fair',
    title: 'Scholastic Book Fair',
    titleES: 'Feria del Libro Scholastic',
    date: new Date(2026, 11, 4),
    category: 'community',
    allDay: true,
    description: 'The Scholastic Book Fair runs Monday, November 30 through Friday, December 4.',
    descriptionES: 'La Feria del Libro Scholastic se realiza del lunes 30 de noviembre al viernes 4 de diciembre.'
  },
  {
    id: 'dec-4-2026-healthy-smiles',
    title: 'Healthy Smiles Dental Program',
    titleES: 'Programa Dental Sonrisas Saludables',
    date: new Date(2026, 11, 4),
    category: 'academic',
    allDay: true,
    description: 'Free dental care at school through the Healthy Smiles program.',
    descriptionES: 'Atención dental gratuita en la escuela a través del programa Sonrisas Saludables.'
  },
  // November 2026 Events, from the school's November 2026 calendar
  {
    id: 'nov-2-2026-nyc-schools-account',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Inscribirse en la Cuenta de las Escuelas de NYC',
    date: new Date(2026, 10, 2),
    category: 'community',
    startTime: '9:30 AM',
    description: 'Get help creating or signing in to your NYC Schools Account.',
    descriptionES: 'Reciba ayuda para crear o iniciar sesión en su Cuenta de las Escuelas de NYC.'
  },
  {
    id: 'nov-3-2026-election-day',
    title: 'Election Day: Remote Learning Day',
    titleES: 'Día de las Elecciones: Día de Aprendizaje a Distancia',
    date: new Date(2026, 10, 3),
    category: 'academic',
    allDay: true,
    description: 'School building closed. Students learn remotely today.',
    descriptionES: 'El edificio escolar está cerrado. Los estudiantes aprenden a distancia hoy.'
  },
  {
    id: 'nov-4-2026-double-dollar',
    title: 'ClassBank Double Dollar Attendance Day',
    titleES: 'Día de Asistencia de Dólar Doble en ClassBank',
    date: new Date(2026, 10, 4),
    category: 'academic',
    allDay: true,
    description: 'Students earn $2 in ClassBank for coming to school today.',
    descriptionES: 'Los estudiantes ganan $2 en ClassBank por asistir a la escuela hoy.'
  },
  {
    id: 'nov-5-2026-parent-teacher-conferences',
    title: 'Parent-Teacher Conferences: Half Day, 11:30 AM Dismissal',
    titleES: 'Reuniones de Padres y Maestros: Medio Día, Salida a las 11:30 AM',
    date: new Date(2026, 10, 5),
    category: 'earlyDismissal',
    allDay: true,
    description: 'Students are dismissed at 11:30 AM for afternoon and evening parent-teacher conferences.',
    descriptionES: 'Los estudiantes salen a las 11:30 AM por las reuniones de padres y maestros de la tarde y la noche.'
  },
  {
    id: 'nov-5-2026-double-dollar',
    title: 'ClassBank Double Dollar Attendance Day',
    titleES: 'Día de Asistencia de Dólar Doble en ClassBank',
    date: new Date(2026, 10, 5),
    category: 'academic',
    allDay: true,
    description: 'Students earn $2 in ClassBank for coming to school today.',
    descriptionES: 'Los estudiantes ganan $2 en ClassBank por asistir a la escuela hoy.'
  },
  {
    id: 'nov-6-2026-fall-show',
    title: 'Fall Show Performance',
    titleES: 'Actuación del Espectáculo de Otoño',
    date: new Date(2026, 10, 6),
    category: 'academic',
    startTime: '9:00 AM',
    endTime: '10:00 AM'
  },
  {
    id: 'nov-9-2026-nyc-schools-account',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Inscribirse en la Cuenta de las Escuelas de NYC',
    date: new Date(2026, 10, 9),
    category: 'community',
    startTime: '9:30 AM',
    description: 'Get help creating or signing in to your NYC Schools Account.',
    descriptionES: 'Reciba ayuda para crear o iniciar sesión en su Cuenta de las Escuelas de NYC.'
  },
  {
    id: 'nov-10-2026-double-dollar',
    title: 'ClassBank Double Dollar Attendance Day',
    titleES: 'Día de Asistencia de Dólar Doble en ClassBank',
    date: new Date(2026, 10, 10),
    category: 'academic',
    allDay: true,
    description: 'Students earn $2 in ClassBank for coming to school today.',
    descriptionES: 'Los estudiantes ganan $2 en ClassBank por asistir a la escuela hoy.'
  },
  {
    id: 'nov-10-2026-food-pantry',
    title: 'Food Pantry (Every Tuesday)',
    titleES: 'Despensa de Alimentos (Todos los Martes)',
    date: new Date(2026, 10, 10),
    category: 'community',
    startTime: '2:30 PM',
    endTime: '3:00 PM',
    location: 'Main Lobby',
    description: 'Free groceries for PS 96 families, brought to us by Global Kids. The food pantry is open every Tuesday.',
    descriptionES: 'Alimentos gratis para las familias de PS 96, gracias a Global Kids. La despensa de alimentos abre todos los martes.'
  },
  {
    id: 'nov-11-2026-veterans-day',
    title: 'Veterans Day: School Closed',
    titleES: 'Día de los Veteranos: No Hay Clases',
    date: new Date(2026, 10, 11),
    category: 'holiday',
    allDay: true,
    description: 'Schools closed.',
    descriptionES: 'No hay clases.'
  },
  {
    id: 'nov-12-2026-wear-blue',
    title: 'Wear Blue for Paraprofessionals!',
    titleES: '¡Vístase de Azul para los Paraprofesionales!',
    date: new Date(2026, 10, 12),
    category: 'academic',
    allDay: true,
    description: 'Show your appreciation for our paraprofessionals by wearing blue.',
    descriptionES: 'Muestre su aprecio por nuestros paraprofesionales vistiendo de azul.'
  },
  {
    id: 'nov-12-2026-double-dollar',
    title: 'ClassBank Double Dollar Attendance Day',
    titleES: 'Día de Asistencia de Dólar Doble en ClassBank',
    date: new Date(2026, 10, 12),
    category: 'academic',
    allDay: true,
    description: 'Students earn $2 in ClassBank for coming to school today.',
    descriptionES: 'Los estudiantes ganan $2 en ClassBank por asistir a la escuela hoy.'
  },
  {
    id: 'nov-13-2026-high-school-fair',
    title: 'High School Fair',
    titleES: 'Feria de la Escuela Secundaria',
    date: new Date(2026, 10, 13),
    category: 'academic',
    startTime: '8:30 AM'
  },
  {
    id: 'nov-16-2026-nyc-schools-account',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Inscribirse en la Cuenta de las Escuelas de NYC',
    date: new Date(2026, 10, 16),
    category: 'community',
    startTime: '9:30 AM',
    description: 'Get help creating or signing in to your NYC Schools Account.',
    descriptionES: 'Reciba ayuda para crear o iniciar sesión en su Cuenta de las Escuelas de NYC.'
  },
  {
    id: 'nov-17-2026-food-pantry',
    title: 'Food Pantry (Every Tuesday)',
    titleES: 'Despensa de Alimentos (Todos los Martes)',
    date: new Date(2026, 10, 17),
    category: 'community',
    startTime: '2:30 PM',
    endTime: '3:00 PM',
    location: 'Main Lobby',
    description: 'Free groceries for PS 96 families, brought to us by Global Kids. The food pantry is open every Tuesday.',
    descriptionES: 'Alimentos gratis para las familias de PS 96, gracias a Global Kids. La despensa de alimentos abre todos los martes.'
  },
  {
    id: 'nov-19-2026-parent-association-meeting',
    title: 'Parent Association Meeting',
    titleES: 'Reunión de la Asociación de Padres',
    date: new Date(2026, 10, 19),
    category: 'pta',
    startTime: '2:30 PM'
  },
  {
    id: 'nov-23-2026-nyc-schools-account',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Inscribirse en la Cuenta de las Escuelas de NYC',
    date: new Date(2026, 10, 23),
    category: 'community',
    startTime: '9:30 AM',
    description: 'Get help creating or signing in to your NYC Schools Account.',
    descriptionES: 'Reciba ayuda para crear o iniciar sesión en su Cuenta de las Escuelas de NYC.'
  },
  {
    id: 'nov-24-2026-fall-festival',
    title: 'Fall Festival: Food, Games, Prizes & More!',
    titleES: 'Festival de Otoño: ¡Comida, Juegos, Premios y Mucho Más!',
    date: new Date(2026, 10, 24),
    category: 'community',
    startTime: '2:30 PM'
  },
  {
    id: 'nov-24-2026-food-pantry',
    title: 'Food Pantry (Every Tuesday)',
    titleES: 'Despensa de Alimentos (Todos los Martes)',
    date: new Date(2026, 10, 24),
    category: 'community',
    startTime: '2:30 PM',
    endTime: '3:00 PM',
    location: 'Main Lobby',
    description: 'Free groceries for PS 96 families, brought to us by Global Kids. The food pantry is open every Tuesday.',
    descriptionES: 'Alimentos gratis para las familias de PS 96, gracias a Global Kids. La despensa de alimentos abre todos los martes.'
  },
  {
    id: 'nov-25-2026-healthy-smiles',
    title: 'Healthy Smiles Dental Program',
    titleES: 'Programa Dental Sonrisas Saludables',
    date: new Date(2026, 10, 25),
    category: 'academic',
    allDay: true,
    description: 'Free dental care at school through the Healthy Smiles program.',
    descriptionES: 'Atención dental gratuita en la escuela a través del programa Sonrisas Saludables.'
  },
  {
    id: 'nov-26-2026-thanksgiving',
    title: 'Thanksgiving Recess: School Closed',
    titleES: 'Receso de Acción de Gracias: No Hay Clases',
    date: new Date(2026, 10, 26),
    category: 'holiday',
    allDay: true,
    description: 'Schools closed.',
    descriptionES: 'No hay clases.'
  },
  {
    id: 'nov-27-2026-thanksgiving',
    title: 'Thanksgiving Recess: School Closed',
    titleES: 'Receso de Acción de Gracias: No Hay Clases',
    date: new Date(2026, 10, 27),
    category: 'holiday',
    allDay: true,
    description: 'Schools closed.',
    descriptionES: 'No hay clases.'
  },
  {
    id: 'nov-30-2026-nyc-schools-account',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Inscribirse en la Cuenta de las Escuelas de NYC',
    date: new Date(2026, 10, 30),
    category: 'community',
    startTime: '9:30 AM',
    description: 'Get help creating or signing in to your NYC Schools Account.',
    descriptionES: 'Reciba ayuda para crear o iniciar sesión en su Cuenta de las Escuelas de NYC.'
  },
  {
    id: 'nov-30-2026-book-fair',
    title: 'Scholastic Book Fair',
    titleES: 'Feria del Libro Scholastic',
    date: new Date(2026, 10, 30),
    category: 'community',
    allDay: true,
    description: 'The Scholastic Book Fair runs Monday, November 30 through Friday, December 4.',
    descriptionES: 'La Feria del Libro Scholastic se realiza del lunes 30 de noviembre al viernes 4 de diciembre.'
  },
  // October 2026 Events
  {
    id: 'oct-5-2026-classbank-shop-1',
    title: 'ClassBank Store Open (Oct 5 – Oct 14)',
    titleES: 'Tienda ClassBank Abierta (5 – 14 oct)',
    date: new Date(2026, 9, 5),
    category: 'academic',
    allDay: true,
    description: 'Students can shop in the ClassBank school store through Wednesday, Oct 14. Purchases are delivered Friday, Oct 16.',
    descriptionES: 'Los estudiantes pueden comprar en la tienda escolar ClassBank hasta el miércoles 14 de octubre. Las compras se entregan el viernes 16 de octubre.'
  },
  {
    id: 'oct-9-2026-double-dollar',
    title: 'ClassBank Double Dollar Attendance Day',
    titleES: 'Día de Asistencia de Dólar Doble en ClassBank',
    date: new Date(2026, 9, 9),
    category: 'academic',
    allDay: true,
    description: 'Students earn $2 in ClassBank for coming to school today.',
    descriptionES: 'Los estudiantes ganan $2 en ClassBank por asistir a la escuela hoy.'
  },
  {
    id: 'oct-13-2026-double-dollar',
    title: 'ClassBank Double Dollar Attendance Day',
    titleES: 'Día de Asistencia de Dólar Doble en ClassBank',
    date: new Date(2026, 9, 13),
    category: 'academic',
    allDay: true,
    description: 'Students earn $2 in ClassBank for coming to school today.',
    descriptionES: 'Los estudiantes ganan $2 en ClassBank por asistir a la escuela hoy.'
  },
  {
    id: 'oct-16-2026-classbank-delivery',
    title: 'ClassBank Purchases Delivered',
    titleES: 'Entrega de Compras de ClassBank',
    date: new Date(2026, 9, 16),
    category: 'academic',
    allDay: true,
    description: 'Purchases from the Oct 5–14 shopping window are delivered to students.',
    descriptionES: 'Se entregan a los estudiantes las compras de la ventana de compras del 5 al 14 de octubre.'
  },
  {
    id: 'oct-19-2026-classbank-shop-2',
    title: 'ClassBank Store Open (Oct 19 – Oct 28) · Double Dollar Day',
    titleES: 'Tienda ClassBank Abierta (19 – 28 oct) · Día de Dólar Doble',
    date: new Date(2026, 9, 19),
    category: 'academic',
    allDay: true,
    description: 'Students can shop in the ClassBank store through Wednesday, Oct 28, and earn $2 for attendance today. Purchases are delivered Friday, Oct 30.',
    descriptionES: 'Los estudiantes pueden comprar en la tienda ClassBank hasta el miércoles 28 de octubre y ganan $2 por asistencia hoy. Las compras se entregan el viernes 30 de octubre.'
  },
  {
    id: 'oct-26-2026-spirit-week',
    title: 'Spirit Week: Wacky Hair Day',
    titleES: 'Semana del Espíritu: Día de Pelo Alborotado',
    date: new Date(2026, 9, 26),
    category: 'community',
    allDay: true,
    description: 'Wacky Hair Day! Show off your craziest hairstyle for Spirit Week.',
    descriptionES: '¡Muestre su peinado más loco durante la Semana del Espíritu!'
  },
  {
    id: 'oct-27-2026-spirit-week',
    title: 'Spirit Week: Pajama Day',
    titleES: 'Semana del Espíritu: Día de Pijamas',
    date: new Date(2026, 9, 27),
    category: 'community',
    allDay: true,
    description: 'Pajama Day! Wear your comfiest pajamas to school for Spirit Week.',
    descriptionES: '¡Use sus pijamas más cómodas a la escuela durante la Semana del Espíritu!'
  },
  {
    id: 'oct-28-2026-spirit-week',
    title: 'Spirit Week: Wear Orange and Black',
    titleES: 'Semana del Espíritu: Viste de Naranja y Negro',
    date: new Date(2026, 9, 28),
    category: 'community',
    allDay: true,
    description: 'Wear orange and black for Spirit Week! Last day to shop in the ClassBank store this round.',
    descriptionES: '¡Viste de naranja y negro en la Semana del Espíritu! Último día para comprar en la tienda ClassBank en esta ronda.'
  },
  {
    id: 'oct-29-2026-spirit-week',
    title: 'Spirit Week: Silly Sock Day',
    titleES: 'Semana del Espíritu: Día de los Calcetines Divertidos',
    date: new Date(2026, 9, 29),
    category: 'community',
    allDay: true,
    description: 'Silly Sock Day! Wear your wildest socks for Spirit Week.',
    descriptionES: '¡Use sus calcetines más divertidos durante la Semana del Espíritu!'
  },
  {
    id: 'oct-30-2026-spirit-week',
    title: 'Spirit Week: Costume Day',
    titleES: 'Semana del Espíritu: Día de Disfraces',
    date: new Date(2026, 9, 30),
    category: 'community',
    allDay: true,
    description: 'Costume Day! Students may wear costumes for Spirit Week. The ClassBank Student Costume Contest is today, and purchases are delivered.',
    descriptionES: '¡Día de disfraces! Los estudiantes pueden usar disfraces durante la Semana del Espíritu. Hoy es el Concurso de Disfraces de ClassBank y se entregan las compras.'
  },
  // September 2026 Events
  {
    id: 'sep-10-2026-first-day',
    title: 'First Day of School',
    titleES: 'Primer Día de Clases',
    date: new Date(2026, 8, 10),
    category: 'academic',
    allDay: true,
    description: 'Welcome back, Lions! The 2026–2027 school year begins.',
    descriptionES: '¡Bienvenidos, Leones! Comienza el año escolar 2026–2027.'
  },
  {
    id: 'sep-15-2026-nycsa',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Registrarse en una Cuenta de Escuelas de NYC',
    date: new Date(2026, 8, 15),
    category: 'academic',
    startTime: '8:30 AM',
    endTime: '2:30 PM',
    description: 'Drop by for help creating or activating your NYC Schools Account (NYCSA).',
    descriptionES: 'Pase para recibir ayuda para crear o activar su Cuenta de Escuelas de NYC (NYCSA).'
  },
  {
    id: 'sep-18-2026-coffee',
    title: 'Coffee on the Curb',
    titleES: 'Café en la Acera',
    date: new Date(2026, 8, 18),
    category: 'community',
    startTime: '7:45 AM',
    description: 'Join us for coffee outside the school at morning drop-off.',
    descriptionES: 'Acompáñenos a tomar café afuera de la escuela a la hora de entrada.'
  },
  {
    id: 'sep-21-2026-yom-kippur',
    title: 'School Closed - Yom Kippur',
    titleES: 'Escuela Cerrada - Yom Kipur',
    date: new Date(2026, 8, 21),
    category: 'holiday',
    allDay: true,
    description: 'No school - Yom Kippur observance',
    descriptionES: 'No hay clases - Observancia de Yom Kipur'
  },
  {
    id: 'sep-22-2026-nycsa',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Registrarse en una Cuenta de Escuelas de NYC',
    date: new Date(2026, 8, 22),
    category: 'academic',
    startTime: '8:30 AM',
    endTime: '2:30 PM',
    description: 'Drop by for help creating or activating your NYC Schools Account (NYCSA).',
    descriptionES: 'Pase para recibir ayuda para crear o activar su Cuenta de Escuelas de NYC (NYCSA).'
  },
  {
    id: 'sep-26-2026-d4-welcome',
    title: 'District 4 & UFT Welcome Back to School 2026',
    titleES: 'Bienvenida de Regreso a la Escuela 2026 del Distrito 4 y UFT',
    date: new Date(2026, 8, 26),
    category: 'community',
    startTime: '10:00 AM',
    location: 'PS/MS 007, 160 East 120th Street (between Lexington & Third Avenues)',
    description: 'Community School District 4 and the UFT celebrate Hispanic Heritage Month with live music, arts & crafts, giveaways, free raffles, free backpacks, family activities, and school resource information.',
    descriptionES: 'El Distrito Escolar Comunitario 4 y la UFT celebran el Mes de la Herencia Hispana con música en vivo, manualidades, regalos, rifas gratis, mochilas gratis, actividades familiares e información sobre recursos escolares.'
  },
  {
    id: 'sep-28-2026-classbank-store',
    title: 'ClassBank Store Open (Sep 28 – Oct 1)',
    titleES: 'Tienda ClassBank Abierta (28 sep – 1 oct)',
    date: new Date(2026, 8, 28),
    category: 'academic',
    allDay: true,
    description: 'Students can shop in the ClassBank school store Monday, Sept 28 through Thursday, Oct 1. Purchases are delivered Friday, Oct 2.',
    descriptionES: 'Los estudiantes pueden comprar en la tienda escolar ClassBank del lunes 28 de septiembre al jueves 1 de octubre. Las compras se entregan el viernes 2 de octubre.'
  },
  {
    id: 'sep-29-2026-nycsa',
    title: 'NYC Schools Account Sign-Up Support',
    titleES: 'Soporte para Registrarse en una Cuenta de Escuelas de NYC',
    date: new Date(2026, 8, 29),
    category: 'academic',
    startTime: '8:30 AM',
    endTime: '2:30 PM',
    description: 'Drop by for help creating or activating your NYC Schools Account (NYCSA).',
    descriptionES: 'Pase para recibir ayuda para crear o activar su Cuenta de Escuelas de NYC (NYCSA).'
  },
  {
    id: 'sep-30-2026-curriculum-night',
    title: 'Curriculum Night',
    titleES: 'Noche de Presentación del Plan de Estudios',
    date: new Date(2026, 8, 30),
    category: 'academic',
    startTime: '2:30 PM',
    description: "Meet your child's teachers and learn about this year's curriculum. Students earn a $10 ClassBank bonus when a parent or guardian attends!",
    descriptionES: 'Conozca a los maestros de su hijo y aprenda sobre el plan de estudios de este año. ¡Los estudiantes ganan un bono de $10 en ClassBank cuando asiste un padre o tutor!'
  },
  {
    id: 'oct-2-2026-classbank-delivery',
    title: 'ClassBank Purchases Delivered',
    titleES: 'Entrega de Compras de ClassBank',
    date: new Date(2026, 9, 2),
    category: 'academic',
    allDay: true,
    description: 'First ClassBank store purchases are delivered to students.',
    descriptionES: 'Se entregan a los estudiantes las primeras compras de la tienda ClassBank.'
  },
  // October 2025 Events
  {
    id: 'oct-1-2025',
    title: 'Happy Spooky Season',
    titleES: 'Feliz Temporada Espeluznante',
    date: new Date(2025, 9, 1),
    category: 'holiday',
    allDay: true,
    description: 'Welcome to October - Happy Spooky Season!',
    descriptionES: '¡Bienvenido a octubre - Feliz Temporada Espeluznante!'
  },
  {
    id: 'oct-2-2025',
    title: 'School Closed - Yom Kippur',
    titleES: 'Escuela Cerrada - Yom Kipur',
    date: new Date(2025, 9, 2),
    category: 'holiday',
    allDay: true,
    description: 'No school - Yom Kippur observance',
    descriptionES: 'No hay clases - Observancia de Yom Kipur'
  },
  {
    id: 'oct-6-2025-transport',
    title: 'Transportation Orientation & NYC Schools Account Sign-Up Support',
    titleES: 'Orientación de Transporte y Soporte para Cuenta de Escuelas de NYC',
    date: new Date(2025, 9, 6),
    category: 'academic',
    startTime: '8:30 AM',
    description: 'Morning session for transportation orientation and assistance with NYC Schools Account setup',
    descriptionES: 'Sesión matutina para orientación de transporte y asistencia con la configuración de la cuenta de Escuelas de NYC'
  },
  {
    id: 'oct-7-2025-food',
    title: 'Food Pantry',
    titleES: 'Despensa de Alimentos',
    date: new Date(2025, 9, 7),
    category: 'community',
    startTime: '2:30 PM',
    description: 'Monthly food pantry distribution for families in need',
    descriptionES: 'Distribución mensual de despensa de alimentos para familias necesitadas'
  },
  {
    id: 'oct-9-2025-bingo',
    title: 'Family Bingo Night',
    titleES: 'Noche de Bingo Familiar',
    date: new Date(2025, 9, 9),
    category: 'pta',
    startTime: '5:30 PM',
    description: 'Join us for a fun family bingo night!',
    descriptionES: '¡Únase a nosotros para una divertida noche de bingo familiar!'
  },
  {
    id: 'oct-10-2025-global',
    title: 'Global Kids Perfect Attendance Breakfast',
    titleES: 'Desayuno de Asistencia Perfecta de Global Kids',
    date: new Date(2025, 9, 10),
    category: 'academic',
    description: 'Celebrating students with perfect attendance',
    descriptionES: 'Celebrando a los estudiantes con asistencia perfecta'
  },
  {
    id: 'oct-10-2025-mental',
    title: 'Wear Yellow for National Mental Health Day',
    titleES: 'Use Amarillo para el Día Nacional de la Salud Mental',
    date: new Date(2025, 9, 10),
    category: 'community',
    allDay: true,
    description: 'Show support for mental health awareness by wearing yellow',
    descriptionES: 'Muestre su apoyo a la conciencia sobre la salud mental usando amarillo'
  },
  {
    id: 'oct-10-2025-workshop',
    title: 'Mindful Crafting Workshop',
    titleES: 'Taller de Artesanía Consciente',
    date: new Date(2025, 9, 10),
    category: 'afterSchool',
    startTime: '3:30 PM',
    description: 'Creative mindfulness workshop for students',
    descriptionES: 'Taller creativo de mindfulness para estudiantes'
  },
  {
    id: 'oct-13-2025',
    title: 'School Closed - Indigenous Peoples Day',
    titleES: 'Escuela Cerrada - Día de los Pueblos Indígenas',
    date: new Date(2025, 9, 13),
    category: 'holiday',
    allDay: true,
    description: 'No school in observance of Indigenous Peoples Day',
    descriptionES: 'No hay clases en observancia del Día de los Pueblos Indígenas'
  },
  {
    id: 'oct-14-2025-food',
    title: 'Food Pantry',
    titleES: 'Despensa de Alimentos',
    date: new Date(2025, 9, 14),
    category: 'community',
    startTime: '2:30 PM',
    description: 'Monthly food pantry distribution for families in need',
    descriptionES: 'Distribución mensual de despensa de alimentos para familias necesitadas'
  },
  {
    id: 'oct-15-2025-pa',
    title: 'Parent Association Virtual Meeting',
    titleES: 'Reunión Virtual de la Asociación de Padres',
    date: new Date(2025, 9, 15),
    category: 'pta',
    startTime: '7:00 PM',
    description: 'Monthly Parent Association virtual meeting',
    descriptionES: 'Reunión virtual mensual de la Asociación de Padres'
  },
  {
    id: 'oct-16-2025-breast',
    title: 'Wear Pink for Breast Cancer Awareness',
    titleES: 'Use Rosa para la Concienciación del Cáncer de Mama',
    date: new Date(2025, 9, 16),
    category: 'community',
    allDay: true,
    description: 'Support breast cancer awareness by wearing pink',
    descriptionES: 'Apoye la concienciación del cáncer de mama usando rosa'
  },
  {
    id: 'oct-16-2025-bingo',
    title: 'Family Bingo Night',
    titleES: 'Noche de Bingo Familiar',
    date: new Date(2025, 9, 16),
    category: 'pta',
    startTime: '5:30 PM',
    description: 'Join us for a fun family bingo night!',
    descriptionES: '¡Únase a nosotros para una divertida noche de bingo familiar!'
  },
  {
    id: 'oct-17-2025-coffee',
    title: 'Coffee on the Curb',
    titleES: 'Café en la Acera',
    date: new Date(2025, 9, 17),
    category: 'community',
    startTime: '8:45 AM',
    description: 'Morning coffee social for parents and guardians',
    descriptionES: 'Reunión social matutina de café para padres y tutores'
  },
  {
    id: 'oct-17-2025-workshop',
    title: 'Mindful Crafting Workshop',
    titleES: 'Taller de Artesanía Consciente',
    date: new Date(2025, 9, 17),
    category: 'afterSchool',
    startTime: '3:30 PM',
    description: 'Creative mindfulness workshop for students',
    descriptionES: 'Taller creativo de mindfulness para estudiantes'
  },
  {
    id: 'oct-20-2025',
    title: 'School Closed - Diwali',
    titleES: 'Escuela Cerrada - Diwali',
    date: new Date(2025, 9, 20),
    category: 'holiday',
    allDay: true,
    description: 'No school in observance of Diwali',
    descriptionES: 'No hay clases en observancia de Diwali'
  },
  {
    id: 'oct-21-2025-food',
    title: 'Food Pantry',
    titleES: 'Despensa de Alimentos',
    date: new Date(2025, 9, 21),
    category: 'community',
    startTime: '2:30 PM',
    description: 'Monthly food pantry distribution for families in need',
    descriptionES: 'Distribución mensual de despensa de alimentos para familias necesitadas'
  },
  {
    id: 'oct-23-2025-bingo',
    title: 'Family Bingo Night',
    titleES: 'Noche de Bingo Familiar',
    date: new Date(2025, 9, 23),
    category: 'pta',
    startTime: '5:30 PM',
    description: 'Join us for a fun family bingo night!',
    descriptionES: '¡Únase a nosotros para una divertida noche de bingo familiar!'
  },
  {
    id: 'oct-24-2025-hispanic',
    title: 'Hispanic Heritage Showcase',
    titleES: 'Exhibición del Patrimonio Hispano',
    date: new Date(2025, 9, 24),
    category: 'academic',
    startTime: '9:00 AM',
    description: 'Celebrating Hispanic Heritage Month with student performances and presentations',
    descriptionES: 'Celebrando el Mes de la Herencia Hispana con presentaciones y actuaciones estudiantiles'
  },
  {
    id: 'oct-24-2025-workshop',
    title: 'Mindful Crafting Workshop',
    titleES: 'Taller de Artesanía Consciente',
    date: new Date(2025, 9, 24),
    category: 'afterSchool',
    startTime: '3:30 PM',
    description: 'Creative mindfulness workshop for students',
    descriptionES: 'Taller creativo de mindfulness para estudiantes'
  },
  {
    id: 'oct-27-2025-bake',
    title: 'School Bake Sale - All Week During Lunch',
    titleES: 'Venta de Pasteles de la Escuela - Toda la Semana Durante el Almuerzo',
    date: new Date(2025, 9, 27),
    category: 'pta',
    description: 'Support our school with bake sale purchases all week during lunch',
    descriptionES: 'Apoye a nuestra escuela con compras de venta de pasteles toda la semana durante el almuerzo'
  },
  {
    id: 'oct-28-2025-heritage',
    title: 'Hispanic Heritage Family Celebration Dinner',
    titleES: 'Cena de Celebración Familiar de la Herencia Hispana',
    date: new Date(2025, 9, 28),
    category: 'community',
    startTime: '5:00 PM',
    description: 'Join us for a special family dinner celebrating Hispanic Heritage',
    descriptionES: 'Únase a nosotros para una cena familiar especial celebrando la Herencia Hispana'
  },
  {
    id: 'oct-29-2025-kpop-k2',
    title: 'Grades K-2: K-Pop Demon Hunters Watch Party',
    titleES: 'Grados K-2: Fiesta de Visualización de K-Pop Demon Hunters',
    date: new Date(2025, 9, 29),
    category: 'afterSchool',
    startTime: '3:00 PM',
    description: 'Special watch party for grades K-2',
    descriptionES: 'Fiesta de visualización especial para grados K-2'
  },
  {
    id: 'oct-30-2025-kpop-36',
    title: 'Grades 3K-6: K-Pop Demon Hunters Watch Party',
    titleES: 'Grados 3K-6: Fiesta de Visualización de K-Pop Demon Hunters',
    date: new Date(2025, 9, 30),
    category: 'afterSchool',
    startTime: '3:00 PM',
    description: 'Special watch party for grades 3K-6',
    descriptionES: 'Fiesta de visualización especial para grados 3K-6'
  },
  {
    id: 'oct-31-2025-halloween',
    title: 'Grades 3K-5: Halloween Parade',
    titleES: 'Grados 3K-5: Desfile de Halloween',
    date: new Date(2025, 9, 31),
    category: 'community',
    startTime: '1:45 PM',
    description: 'Annual Halloween costume parade for elementary students',
    descriptionES: 'Desfile anual de disfraces de Halloween para estudiantes de primaria'
  },
  {
    id: 'oct-19-2025-breast-walk',
    title: 'Making Strides Against Breast Cancer Walk in Central Park',
    titleES: 'Caminata Avanzando Contra el Cáncer de Mama en Central Park',
    date: new Date(2025, 9, 19),
    category: 'community',
    startTime: '8:00 AM',
    location: 'Central Park - Meet at Naumburg Bandshell: W 67th St & Central Park West',
    description: 'Join the PS 96 community for the Making Strides Against Breast Cancer Walk',
    descriptionES: 'Únase a la comunidad de PS 96 para la Caminata Avanzando Contra el Cáncer de Mama'
  }
];

export default events;
